import { apiFetch } from './api';

export interface PurchaseExtraCreditsRequest {
    creditsAmount: number;
    cardNumber: string;
    cardHolder: string;
    expirationDate: string;
    securityCode: string;
    brand: string;
    customerName: string;
    customerEmail: string;
    customerIdentity: string;
    customerIdentityType: string;
    organizationId?: string; // Opcional para compatibilidade com compras diretas
}

export interface PurchaseExtraCreditsResponse {
    success: boolean;
    message: string;
    creditsAdded: number;
    totalPaid: number;
    pricePerCredit: number;
    transactionId: string;
    invoiceNumber: string;
}

export const purchaseCreditsApi = {
    async purchaseExtraCredits(data: PurchaseExtraCreditsRequest): Promise<PurchaseExtraCreditsResponse> {
        try {
            return await apiFetch<PurchaseExtraCreditsResponse>('/Payment/PurchaseExtraCredits', {
                method: 'POST',
                body: JSON.stringify(data),
                auth: true,
            });
        } catch (error) {
            console.error('Error purchasing extra credits:', error);
            throw error;
        }
    },
};

